import { useDispatch } from "react-redux"
import { PencilIcon } from '@heroicons/react/24/solid'

import { EmptyValuePlaceholder, Toggle } from "@/components/ui"
import { formatDate } from "@/utils/formatters"
import Contact from "../Contact"
import { setMandatInEdition } from '../../mandats/mandatsSlice'
import { useDetailContext } from '@/components/DetailTemplate'
import { FORM_TYPES } from '../../mandats/MandatFormContext'

export default ({item, changeFormType = () => {}}) => {
  const dispatch = useDispatch()
  const detailContext = useDetailContext()

  const handleEditClick = () => {
    dispatch(setMandatInEdition(item))
    if(item.date_fin) {
      changeFormType(FORM_TYPES.CLOSE)
    } else {
      changeFormType(FORM_TYPES.EDIT)
    }
    detailContext.setModalVisible(true)
  }

  const handleCloseClick = () => {
    dispatch(setMandatInEdition(item))
    changeFormType(FORM_TYPES.CLOSE)
    detailContext.setModalVisible(true)
  }

  const isActive = item.date_signature && !item.date_fin

  return (
    <tr data-object="mandat" data-id={item.id}
        className={`text-sm hover:bg-primary-200 transition-all duration-500`}
    >
      <td className="p-1">
        { item.proprietaires_signataires?.length > 0 && item.proprietaires_signataires.map((proprietaire, index) => (
          <Contact key={proprietaire.id} label="Propriétaire" item={proprietaire} index={index} />
        ))}
        { (!item.proprietaires_signataires || item.proprietaires_signataires?.length == 0 ) && (
          <EmptyValuePlaceholder />
        )}
      </td>

      <td className="capitalize">
        { item.type_mandat || <EmptyValuePlaceholder /> }
      </td>

      <td>
        { item.numero || <EmptyValuePlaceholder /> }
      </td>

      <td>
        { item.date_signature ? formatDate(item.date_signature) : 
          <EmptyValuePlaceholder />
        }
      </td>

      <td>
        { item.date_fin ? formatDate(item.date_fin) :
          <EmptyValuePlaceholder />
        }
      </td>

      <td className="text-center">
        { item.type_mandat === "vente" &&
          <Toggle.Display value={item.exclusivite} labelSuffix="" />
        }
      </td>

      <td className="text-end px-2 space-x-2">
        {isActive && (
          <button className='btn btn-primary btn-sm'
            onClick={handleCloseClick}
          >
            Fin de mandat
          </button>
        )}
        <button className="btn btn-sm btn-ghost btn-square hover:bg-primary-400"
          onClick={handleEditClick}
        >
          <PencilIcon className="h-5 w-5"/>
        </button>
      </td>
    </tr>
  )
}